const textMediaElementsRight = document.querySelectorAll('.section--textmedia.media--right')

const changeOrderOfTextMedia = () => {
    if (window.innerWidth >= 768) {
        textMediaElementsRight.forEach(textmedia => {
            const text = textmedia.querySelector('.text--content')
            text.remove()
            textmedia.prepend(text)
        })
    }
    if (window.innerWidth < 768) {
        textMediaElementsRight.forEach(textmedia => {
            const text = textmedia.querySelector('.text--content')
            text.remove()
            textmedia.append(text)
        })
    }
}

window.addEventListener('resize', () => {
    changeOrderOfTextMedia()
});

changeOrderOfTextMedia()